module.exports = __webpack_public_path__ + "assets/img/w-c-s2.f9eecf36.png";